import { FC, useState, useCallback, useEffect, useContext } from "react";
import update from "immutability-helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "reactstrap";
import Path from "../../../images/Path.svg";
import { toast } from "react-toastify";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../../utils/Utils";
import Service from "../../../services";
import { FooterCard } from "./FooterCard";
import ShortcutForm from "./ShortcutForm";
import { BankUserContext } from "../../../bankUserContext";
// import Authorization from "../../Authorization/Authorization";


export interface Item {
  userShortcutId: number;
  name: string;
  displaySequence: number;
  url: string;
  type: number;
}

export interface ContainerState {
  cards: Item[];
}

interface card {
    userQuickLinksId: string;
    name: string;
    displaySequence: number;
    url: string;
    type: number;
    setRefreshShortcuts: (setRefreshShortcuts:boolean)=>void;
  }


interface BankUserProps {
  cardData: any;
}
export const QuickLinksFC: FC<BankUserProps> = (props: BankUserProps) => {
    const service = new Service();
    const [refreshShortcuts, setRefreshShortcuts] = useState(false);
    const [cardsChanged, setCardsChanged] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [hoverIndex, setHoverIndex] = useState(-1);
    const [cards, setCards] = useState<any>([]);
    const bankUserContext=useContext(BankUserContext);
    const moveCard = useCallback((dragIndex: number, innerIndex: number) => {
      setCards((prevCards: Item[]) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [innerIndex, 0, prevCards[dragIndex] as Item],
          ],
        })
      );
      setHoverIndex(innerIndex);
      setCardsChanged(true);
    }, []);

    const cardUpdate = () => {
      if(bankUserContext.bankuserDetails?.userId){
        const quickLinkCards = {
          screen: "LandingPage",    
          sections: "getUserQuickLinks",    
          userId: bankUserContext?.bankuserDetails.userId,
          "isJsonReturnObject":true
        };
        !initialized &&
        service
          .getUserShortcutsByUserId(quickLinkCards)
          .then((resp: AxiosResponse) => {
            setCards(resp?.data);
          })
          .catch((error:AxiosResponse) => {
            catchError(error,true)
          })
          .finally(() => {
            setInitialized(true);
          });
      } 
     
     

      if (cardsChanged && hoverIndex != -1) {
        const data = {
          displaySequence: hoverIndex + 1,
          userQuickLinksId: cards && cards[hoverIndex]?.userQuickLinksId,
        };
        // service
        //   .updateUserShortcut(data)
        //   .then((r) => r)
        //   .catch((e) => e);
        setCardsChanged(false);
      }
    };
    // =======================================================should be dynamic
    useEffect(() => {
      
        const quickLinkCards = {
          screen: "LandingPage",    
          sections: "getUserQuickLinks",    
          userId: bankUserContext?.bankuserDetails?.userId,
          "isJsonReturnObject":true
        };
        service
        .getUserShortcutsByUserId(quickLinkCards)
        .then((resp: any) => {
          setCards(resp?.data || []);
          setRefreshShortcuts(false);
        })
        .catch((error: AxiosError) => {
          catchError(error, true)
        });
      
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshShortcuts]);

    useEffect(() => {
      cardUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardsChanged]);

    

    const [displayShortcutModal, setDisplayShortcutModal] = useState<boolean>();
    const onEditCard = () => {
      if (cards?.length <= 5 || cards?.length === undefined) {
        setDisplayShortcutModal(true);
      } else {
        toast.warn("You are not allowed more than 6 Links", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };

    const toggle = () => {
      setDisplayShortcutModal(!displayShortcutModal);
    };
    const closeToggle = () => {
      setDisplayShortcutModal(false);
    };

    return (
      <>
        {/* <ToastContainer /> */}
        <div className="footerLinksLayer1">
          <div className="footerPath">
            <img src={Path} className="item" alt="QuickLinks"/>
            <span>My Quick Links</span>
          </div>
         <FontAwesomeIcon
            icon={faPlus}
            onClick={() => {
              onEditCard();
            }}
            className="addIcon"
          />{" "}
        </div>
        <div className="bottomLinksContainer">
          {cards?.length > 0
            ? cards?.map(
                (
                  card: card,
                  i: number
                ) => (
                  <FooterCard
                  key={card.userQuickLinksId}
                  index={i}
                  userQuickLinksId={card.userQuickLinksId}
                  name={card.name}
                  moveCard={moveCard}
                  url={card.url}
                  type={card.type}
                  setRefreshShortcuts={setRefreshShortcuts}
                />
                )
              )
            : "Nothing To show"}
        </div>
        <Modal
          className="shortcutModal"
          isOpen={displayShortcutModal}
          fade={false}
          toggle={toggle}
        >
          <ShortcutForm
            cards={cards}
            toggle={() => toggle}
            closeToggle={closeToggle}
            setRefreshShortcuts={setRefreshShortcuts}
          />
        </Modal>
      </>
    );
  }

